<!--suppress ALL -->
<template>
  <div>
    <!-- <download-file :isShowDownloadIcon="true" title="扣款信息查询指引.pdf" uatId="16686126526e9e1d98ea5a84b08923ec" proId="166861efd772672d33995c14cea87027"></download-file> -->
    <div class="fpzPenaltyLayout">
      <m-assembly-table :formData="formData"
                        :columns="columns"
                        :data="data"
                        :pages="pages"
                        :settings="settings"
                        :tableButtons="tableButtons"
                        :loading="loading"
                        :total="total"
                        :pageSize="pageSize"
                        @onSubmit="onSubmit"
                        @onPageSizeChange="onPageSizeChange"
                        @onCurrentPageChange="onCurrentPageChange"
                        @onRowClick="onRowClick"
                        @onView="onView"
                        @onEdit="onEdit"
                        @onDelete="onDelete"
                        @onSelect="onSelect"
                        @onSelectAll="onSelectAll"
                        @onExportClick="onExportClick"
                        ref="searchForm"
                        thDrag
      ></m-assembly-table>
    </div>
    <div style="display:none">
      <iframe id="export" name="export"></iframe>
      <form name="exportPDF" id="exportXls" target="export" method="post" accept-charset="UTF-8">
        <input name="params" id="params"/>
      </form>
    </div>
  </div>
</template>

<script>
  import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
  import axios from 'axios';
  import {formatDateTime} from '@/utils/datetime-format.js';
  import moment from 'moment';
  export default {
    name: 'fpzPenalty',
    components: {mAssemblyTable},
    data: function () {
      return {
        vendorId: 0,
        organizationNameResult: [],
        condition: {},
        billStatus: [],
        sortByList: ['', 'ASC', 'DESC'],
        sort1: 0,
        sortBy: '',
        isPoll: false,
        gender: '',
        loading: true,
        showExportModel: false,
        showPopDemoModel: false,
        postHeaderConf: {
          headers: {'Content-Type': 'application/json'}
        },
        formData: {
          row: 4,
          items: [
            {
              value: '',
              field: 'buyer', // 'orgId',
              disabled: false,
              layout: {
                span: 8,
                offset: 0,
                row: 1
              },
              methods: {
                change: () => {
                  // this.getPenaltyType();
                }
              },
              options: {
                multiple: false,
                values: []
              },
              filterable: true,
              type: 'select',
              title: this.$t('fpzPenalty.t1'), // this.$t('买方'),
              validators: {
                required: {
                  required: true,
                  message: this.$t('common.not_empty_require')
                }
              }
            },
            {
              value: '',
              field: 'penaltyTypeCode', // 'penaltyTypeId',
              disabled: false,
              filterable: true,
              layout: {
                span: 8,
                offset: 0,
                row: 1
              },
              options: {
                multiple: false,
                values: []
              },
              type: 'select',
              title: this.$t('fpzPenalty.t2'), // '罚款类型'
            },
            {
              value: '',
              field: 'status',
              disabled: false,
              filterable: true,
              layout: {
                span: 8,
                offset: 0,
                row: 1
              },
              options: {
                multiple: false,
                values: []
              },
              type: 'select',
              title: this.$t('fpzPenalty.t3'), // '状态'
            },
            {
              value: '',
              field: 'creationDateFrom',
              layout: {
                row: 2,
                span: 8,
                offset: 0
              },
              options: {
                type: 'date',
                format: 'yyyy-MM-dd'
              },
              style: 'width:100%',
              type: 'datePicker',
              title: this.$t('fpzPenalty.t4'), // '罚扣款日期',
              placeholder: '',
              isDouble: true
            },
            {
              hide: true,
              value: '',
              field: 'creationDateTo',
              layout: {
                span: 4,
                offset: 0,
                row: 2
              },
              options: {
                type: 'date',
                format: 'yyyy-MM-dd',
                options: {
                  disabledDate(date) {
                  }
                }
              },
              style: 'width:100%',
              type: 'datePicker',
              title: ''
            },
            {
              isDouble: true,
              value: '',
              field: 'penaltyNumberFrom',
              disabled: false,
              layout: {
                span: 8,
                offset: 0,
                row: 2
              },
              options: {
                rows: 1,
                type: 'text'
              },
              type: 'text',
              title: this.$t('fpzPenalty.t5'), // '罚扣款编号'
            },
            {
              hide: true,
              value: '',
              field: 'penaltyNumberTo',
              disabled: false,
              layout: {
                span: 8,
                offset: 0,
                row: 2
              },
              options: {
                rows: 1,
                type: 'text'
              },
              type: 'text',
              title: this.$t('fpzPenalty.t6'), // '罚扣款编号至'
            }
          ],
          buttons: {
            submitText: this.$t('common.queryBtn'), // '查找',
            resetText: this.$t('common.clearBtn'), // '清除'
          }
        },
        columns: {
          columns: [
            {
              renderHeader: (h, params) => {
                return h('span', this.$t('fpzPenalty.t5')); // '罚扣款编号');
              },
              key: 'penaltyNumber',
              sortable: true,
              align: 'center',
              minWidth: 180
            },
            {
              renderHeader: (h, params) => {
                return h('span', this.$t('fpzPenalty.t7')); // 类别
              },
              key: 'penaltyTypeName',
              align: 'center',
              minWidth: 100
            },
            {
              renderHeader: (h, params) => {
                return h('span', this.$t('fpzPenalty.t8')); // 标题
              },
              key: 'penaltyTitle',
              minWidth: 200
            },
            {
              renderHeader: (h, params) => {
                return h('span', this.$t('fpzPenalty.t1')); // 买方
              },
              key: 'buyer',
              sortable: true,
              minWidth: 170,
              render: (h, params) => {
                return h('Tooltip', {
                    props: {
                        content: params.row.buyer,
                        placement: 'top'
                    },
                    class: 'm-tooltip-overflow'
                }, params.row.buyer);
              }
            },
            {
              renderHeader: (h, params) => {
                return h('span', this.$t('fpzPenalty.t17')); // 物料编码
              },
              key: 'itemCode',
              sortable: true,
              align: 'center',
              minWidth: 110
            },
            {
              renderHeader: (h, params) => {
                return h('span', this.$t('fpzPenalty.t18')); // 数量
              },
              key: 'quantity',
              sortable: true,
              align: 'center',
              minWidth: 60
            },
            {
              renderHeader: (h, params) => {
                return h('span', this.$t('fpzPenalty.t19')); // 单价
              },
              key: 'price',
              sortable: true,
              align: 'center',
              minWidth: 60
            },
            {
              renderHeader: (h, params) => {
                return h('span', this.$t('fpzPenalty.t9')); // 币种
              },
              key: 'currency',
              sortable: true,
              align: 'center',
              minWidth: 60
            },
            {
              renderHeader: (h, params) => {
                return h('span', this.$t('fpzPenalty.t10')); // 扣款金额
              },
              key: 'amount',
              align: 'right',
              minWidth: 80
            },
            {
              renderHeader: (h, params) => {
                  return h('div', {
                      on: {
                          'click': () => {
                              this.sort1 = 0;
                              this.sortData();
                          }
                      }
                  }, [
                      h('span', {}, this.$t('fpzPenalty.t11')), // 扣款日期
                      h('span', {
                          class: 'm-table-sort'
                      }, [
                          h('i', {
                              class: 'm-icon m-icon-arrow-up-b',
                              style: {color: this.sortByList[this.sort1] === 'ASC' ? '#3aa2eb' : ''},
                              on: {
                                  'click': (e) => {
                                      e.stopPropagation();
                                      this.sort1 = 1;
                                      this.sortData(this.sortByList[1]);
                                  }
                              }
                          }),
                          h('i', {
                              class: 'm-icon m-icon-arrow-down-b',
                              style: {color: this.sortByList[this.sort1] === 'DESC' ? '#3aa2eb' : ''},
                              on: {
                                  'click': (e) => {
                                      e.stopPropagation();
                                      this.sort1 = 2;
                                      this.sortData(this.sortByList[2]);
                                  }
                              }
                          })
                      ])
                  ]);
              },
              key: 'creationDate',
              align: 'center',
              minWidth: 90
            },
            {
              renderHeader: (h, params) => {
                return h('span', this.$t('fpzPenalty.t3')); // 状态
              },
              key: 'status',
              align: 'center',
              minWidth: 90
            },
            {
              renderHeader: (h, params) => {
                return h('span', this.$t('fpzPenalty.t12')); // 发票号
              },
              key: 'invoiceNum',
              align: 'center',
              minWidth: 120
            }
          ]
        },
        tableButtons: {
          systemButtons: [],
          customButtons: [
            {
              name: '',
              label: this.$t('common.export'), // '导出',
              icon: 'ios-down',
              click: (button) => {
                if (!this.$refs['searchForm'].$refs.queryForm.validateForm()) {
                    return false;
                }
                this.$set(button, 'loading', true);
                var a = document.createElement('a');
                let params = {
                  countStatus: 'Y',
                  pageSize: 999,
                  pageIndex: this.pages,
                  buyer: this.formData.items[0].value,
                  vendorId: this.vendorId,
                  penaltyTypeCode: this.formData.items[1].value,
                  status: this.formData.items[2].value,
                  creationDateFrom: this.formData.items[3].value ? formatDateTime(new Date(this.formData.items[3].value), 'yyyy-MM-dd') : '',
                  creationDateTo: this.formData.items[4].value ? formatDateTime(new Date(this.formData.items[4].value), 'yyyy-MM-dd') : '',
                  penaltyNumberFrom: this.formData.items[5].value,
                  penaltyNumberTo: this.formData.items[6].value,
                  sortBy: this.sortBy,
                  language: this.$i18n.locale,
                  vendorCode: this.vendorCode,
                };
                axios.post('/gscint/hwPenalty/export', params, {
                    responseType: 'blob',
                    headers: { 
                        'Content-Type': 'application/json;charset=UTF-8' 
                    }
                })
                .then((res) => {
                    this.$set(button, 'loading', false);
                    this.downloadFile(res.data, '扣罚信息查询.xlsx');
                })
                .catch(() => {
                    this.$set(button, 'loading', false);
                });
              }
            }
          ]
        },
        data: [],
        pages: 1,
        total: 0,
        pageSize: 10,
        settings: {
          needPager: true,
          showElevator: true,
          showSizer: true,
          pageSizeOpts: [10, 30, 50, 80],
          needSearch: true,
          needValidation: true
        },
        tableTitle: '扣款信息查询'
      };
    },
    methods: {
      validIsMf() {
        let isMf = window.environment.isPro ? window.location.pathname === '/gn/meifu.html' : window.location.pathname === '/meifu.html';
        return isMf;
      },
      /** 请求接口进行排序
       * params: 排序方式（ASC正序，DESC反序）
       * */
      sortData(sortBy) {
          this.sortBy = sortBy;
          this.seach();
      },
      seach() {
        this.loading = true;
        let postData = this.getFormDataVModel(this.formData.items);
        axios.post('/gscint/hwPenalty/queryPage', {
          ...postData,
          creationDateFrom: postData.creationDateFrom ? moment(postData.creationDateFrom).format('YYYY-MM-DD') : undefined,
          creationDateTo: postData.creationDateTo ? moment(postData.creationDateTo).format('YYYY-MM-DD') : undefined,
          pageSize: this.pageSize,
          pageIndex: this.pages,
          vendorId: this.vendorId,
          vendorCode: this.vendorCode,
          sortBy: this.sortBy,
          language: this.$i18n.locale
        })
        .then(resp => {
          console.log('123123::::', resp);
          let res = resp.data.data;
          if (res.code == 1) {
            this.data = res.datas.list;
            this.total = res.datas.total;
          } else {
            this.$Modal.error({
              title: this.$t('common.warn'),
              content: res.msg,
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.showErrorTips();
        });
      },
      condition2params(condition) {
        let params = [];
        for (var key of Object.keys(condition)) {
          if (condition[key] && condition[key].length > 0) {
            params.push({name: key, value: condition[key]});
          }
        }
        return params;
      },
      getPenaltyType() {
        console.log(this.formData.items[0].value);
        if (this.formData.items[0].value) {
          axios.post('/gscapp/erpQuery/getPenaltyType', {
            pageSize: 99,
            pageIndex: 1,
            countStatus: 'N',
            orgId: this.formData.items[0].value,
            buyer: this.formData.items[0].value,
          })
          .then(resp => {
            this.formData.items[1].options.values = resp.data.data;
          }).catch(err => {
            this.$Modal.error({
              title: this.$t('common.warn'),
              content: this.$t('common.error1'),
              error: err.stack.toString()
            });
          });
        }
      },
      // getIspInvoiceStatus() {
      //   this.formData.items[2].options.values = [{'value': 0, 'label': '创建'},
      //     {'value': 1, 'label': 'ISP发票匹配'},
      //     {'value': 3, 'label': '发票匹配'},
      //     {'value': 4, 'label': '已低开发票'},
      //     {'value': 9, 'label': '已拆分'},
      //     {'value': 10, 'label': '发票取消'},
      //     {'value': 15, 'label': '已完成'}];
      // },
      onExportClick() {
      },
      onPopDemoModalOkClick() {
        // 点击弹窗的确定按钮，给输入框赋新值
        this.formData.items[5].value = this.gender;
      },
      onSelectChange(value) {
        this.gender = value;
      },
      onSubmit(current, pageSize, condition) {
        this.condition = condition;
        this.pages = current;
        this.pageSize = pageSize;
        this.seach();
      },
      // 页容量改变时触发
      onPageSizeChange(currentPage, pageSize, condition) {
        this.pageSize = pageSize;
        this.seach();
      },
      // 当前页改变时触发
      onCurrentPageChange(current) {
        this.pages = current;
        this.seach();
      },
      onView(row, column, index) {
        // alert('查看按钮点击事件');
      },
      onEdit(row, column, index) {
        // alert('编辑按钮点击事件');
      },
      onDelete(row, column, index) {
        // alert('删除按钮点击事件');
      },
      onRowClick(row, index) {
        // alert('点击了第 ' + index + ' 行');
      },
      onSelect(selection, row) {
        // alert('选中了名字为 ' + row.name + ' 的数据');
      },
      onSelectAll(selection) {
      },
      getOrgList (callBack = null) {
        axios.get('/gscint/vendor/getOULovNew2', {
            params: {
                labelName: 'ouName',
                valueName: 'erpOuId'
            }
        })
        .then((res) => {
            let data = res.data.data;
            if (data) {
                callBack && callBack(res.data.data);
            }
        });
    }
    },
    mounted() {
      this.vendorCode = JSON.parse(
        localStorage.getItem("supplierInfo")
      ).vendorCode;
      this.vendorId = JSON.parse(
        localStorage.getItem("supplierInfo")
      ).vendorId;
      this.loading = false;
      this.getOrgList((data) => {
          data.forEach((item) => {
              item.value = Number(item.value); 
          });
          this.getFormDataItemObj(this.formData.items, 'buyer').options.values = data;
      });
      this.getDict('INT_PENALTY_TYPE', (data) => {
          data.forEach(item => {
            item.label = item.value
          })
          this.getFormDataItemObj(this.formData.items, 'penaltyTypeCode').options.values = data;
      });
      this.getDict('INT_PENALTY_STATUS', (data) => {
          data.forEach(item => {
            item.label = item.value
          })
          this.getFormDataItemObj(this.formData.items, 'status').options.values = data;
      });
    },
    watch: {
      showPopDemoModel(val) {
        if (val) {
          this.gender = '';
        }
      }
    }
  };
</script>
